<div style="text-align: center;">
  <div class="titulo">{{titulo}}</div>
  <div class="subtitulo">{{subtitulo}}</div>
  <div class="moneda">({{moneda}})</div>
</div>

<dx-data-grid id="gridContainer"
    [dataSource]="dataSource"
    [remoteOperations]="false"
    [columnAutoWidth]="true"
    width="auto"
    [allowColumnReordering]="false"
    [rowAlternationEnabled]="true"
    wordWrapEnabled="true"
    [showBorders]="true">

    <dxo-paging [pageSize]="25"></dxo-paging>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-search-panel
        [visible]="true"
        [highlightCaseSensitive]="false"
        [searchVisibleColumnsOnly]="true"
        placeholder="Buscar..."
    ></dxo-search-panel>

    <dxi-column dataField="codigo_sisin" width="120" alignment="right" cellTemplate="discountCellTemplate"></dxi-column>
    <dxi-column dataField="nombre_formal" caption="Proyecto" dataType="string"></dxi-column>
    <div *dxTemplate="let d of 'discountCellTemplate'">
      <a routerLink="" (click)="open2(d.data.url_proyecto)">{{d.data.codigo_sisin}}</a>
    </div>
    <dxi-column dataField="presupuesto" captio="Programado" width="120" alignment="right" dataType="number">
      <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
    </dxi-column>
    <dxi-column dataField="reprogramado" width="140" alignment="right" dataType="number">
      <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
    </dxi-column>
    <dxi-column dataField="ejecutado" width="100" alignment="right" dataType="number">
      <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
    </dxi-column>
    <dxi-column dataField="porc_div" caption="%Ejec/Presup" width="130" alignment="right" dataType="number">
      <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
    </dxi-column>
</dx-data-grid>
<dx-load-panel
                        #loadPanel
                        shadingColor="rgba(0,0,0,0.4)"
                        message="Cargando..."
                        [(visible)]="loadingVisible"
                        [showIndicator]="true"
                        [showPane]="true"
                        [shading]="true"
                        [closeOnOutsideClick]="false">
                      </dx-load-panel>
                    <dx-popup
                      class="popup"
                      minWidth="400px"
                      fullScreen="true"
                      [showTitle]="false"
                      title="Evolución de la Ejecución"
                      [dragEnabled]="false"
                      [closeOnOutsideClick]="true"
                      [(visible)]="popupVisible">
                      <div *dxTemplate="let data of 'content'">
                        <div style="text-align: right;">
                          <div style="float:left; font-size: 18px;font-weight: bold;line-height: 2;">
                            
                          </div>
                          <dx-button 
                            id="button"
                            icon="close"
                            (onClick)="popupVisible=false;">
                          </dx-button>
                        </div>
                        <iframe 
                          [src]="pdfSrc"
                          style="width: 100%;height: 100%"
                          type="application/pdf">
                        </iframe>  
                      </div>
                    </dx-popup>


// WEBPACK FOOTER //
// ./src/app/pages/report/project-view/project-view.component.html